import React from 'react'

const AdditionalConfigSuggestedOption = () => {
  return (
    <>
      <span>Será sugerido durante el proceso de creación de los formularios de la entidad.</span>
      <br />
      <span>
        El creador del formulario puede editar el horario o mantener el sugerido, pero este no será un campo
        obligatorio.
      </span>
    </>
  )
}

export default AdditionalConfigSuggestedOption
